import { FormContext, FormContextType } from '../context';
import React from 'react';

export function useFormContext<T, F = void>() {
  //const test = createFormContext<T>();
  const context = React.useContext<FormContextType<T, F>>(
    FormContext as unknown as React.Context<FormContextType<T, F>>
  );
  if (!context) {
    throw new Error('useMyContext must be used under MyContextProvider');
  }
  return context;
}
